"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colord_1 = require("colord");
var a11y_1 = __importDefault(require("colord/plugins/a11y"));
var names_1 = __importDefault(require("colord/plugins/names"));
(0, colord_1.extend)([a11y_1.default, names_1.default]);
var thresholds = {
    ui: 3,
    text: 4.5,
};
var lumaDiff = function (backgroundColor, foregoundColor) {
    return (0, colord_1.colord)(foregoundColor).contrast(backgroundColor);
};
var goldilocks = function (backgroundColor, _a) {
    var e_1, _b;
    var mode = _a.mode, foregroundColor = _a.foregroundColor;
    var slate = "#47535D";
    var midnight = "#242C39";
    var fgColors = [foregroundColor, slate, midnight, "white"];
    try {
        for (var fgColors_1 = __values(fgColors), fgColors_1_1 = fgColors_1.next(); !fgColors_1_1.done; fgColors_1_1 = fgColors_1.next()) {
            var fgColor = fgColors_1_1.value;
            if (!fgColor) {
                continue;
            }
            if (lumaDiff(backgroundColor, fgColor) > thresholds[mode]) {
                return fgColor;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (fgColors_1_1 && !fgColors_1_1.done && (_b = fgColors_1.return)) _b.call(fgColors_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return "black";
};
exports.default = goldilocks;
